import { Component, OnInit } from '@angular/core';
import { IrpfListModel } from './irpfList.model';
import { InvoiceService } from '../../invoice/invoice/invoice.service';
import { Router } from "@angular/router";
import * as FileSaver from 'file-saver';
import { InvoicesIrpfListConst } from '../../expense/const';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-irpfinvoicelist',
    styleUrls: ['./irpf-list.component.css'],
    templateUrl: 'irpf-list.component.html',
    standalone: false
})
export class IrpfInvoiceListComponent implements OnInit {

    constructor(
        private invoiceService: InvoiceService,
        private router: Router) { }

    empty: boolean = false;
    spinner: boolean = false;
    irpfList: IrpfListModel[] = [];
    trimester: string;
    headerTable: any[] = InvoicesIrpfListConst.headerTable;

    trimesterOptions: Option[] = [
        { label: '1er trimestre', value: '1' },
        { label: '2º trimestre', value: '2' },
        { label: '3er trimestre', value: '3' },
        { label: '4º trimestre', value: '4' },
        { label: 'Anual', value: '5' },
    ];

    get totalBase(): number {
        return this.irpfList.reduce((sum, r) => sum + (Number(r.base) || 0), 0);
    }

    get totalAmount(): number {
        return this.irpfList.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
    }

    ngOnInit() {
        const params = this.router.url.split('/');
        this.trimester = params[3];
        if (this.trimester) {
            this.load();
        }
    }

    change() {
        this.router.navigate(['/invoice/irpf/' + this.trimester]);
        this.load();
    }

    private load(): void {
        this.spinner = true;
        this.empty = false;
        this.irpfList = [];
        this.invoiceService.irpfList(this.trimester, false).then(response => {
            this.irpfList = response;
            this.spinner = false;
            this.empty = this.irpfList.length === 0;
        }).catch(() => {
            this.spinner = false;
            this.empty = true;
        });
    }

    export(): void {
        this.spinner = true;
        const data = new IrpfListModel;
        data.trimester = this.trimester;
        this.invoiceService.exportIrpfList(data, false).then(response => {
            FileSaver.saveAs(response, Utils.GetExcelName("IRPF_Acuenta"));
            this.spinner = false;
        }).catch(() => {
            this.spinner = false;
        });
    }

    pdf(invoiceUid: string, invoiceNumber: string): void {
        this.spinner = true;
        this.invoiceService.pdf(invoiceUid, consts.EMPTY_GUID).then(response => {
            FileSaver.saveAs(response, Utils.GetPdfName("Factura_" + invoiceNumber));
            this.spinner = false;
        });
    }

    public trackByIndex(i: number) { return i; }
}
